import React from 'react';

import { Logo, PoweredByText, PoweredByWrapper } from './styles';

export interface Props {
  dark?: boolean;
}

const PoweredBy: React.FunctionComponent<Props> = ({ dark }) => {
  return (
    <PoweredByWrapper>
      <PoweredByText isDark={dark}>Powered By</PoweredByText>
      <Logo isDark={dark} />
    </PoweredByWrapper>
  );
};

export default PoweredBy;
